export default "__VITE_ASSET__f3501258__"